import { getParamValue } from "../helpers/parameter.accessors"
import { paramKey, paramValue } from "../constants/parameterNames";
import { failure } from "../helpers/commandResult";

const description = 'Retrieves the value of an environment variable';

const requiredParameters = {
    [paramKey]: {
        description: 'The key of the environment variable to retrieve (case sensitive)',
    },
};

const execute = ({ settings, parameters }) => {
    const key = getParamValue(parameters, paramKey);

    const ev = settings.getEnvironmentVariable(key);

    if (!ev) {
        return failure('The specified environment variable was not found.');
    }

    return ev.value || '';
};


const GetEnvironmentVariable = {
    description,
    requiredParameters,
    execute,
};


export default GetEnvironmentVariable;